import $ from 'jquery';
// import { switchEditorModeClickListener } from '~loader/loader-utils';
import { deleteUserFormat } from '../loader-api';
import { getState } from '~src/state';
import Swal from 'sweetalert2';
import { renderLoader } from '~loader/renderLoader';
import { onErrorShowMessage, genericSuccess } from '~src/errors';
import { templateCollapseBox } from '~loader/loader-template';
import { requestNewFormat } from '~src/userRequest';
import { fetchCountEditorProjectsByFormat } from '../../~graphql/controllers';
import { importPublisherFromStart } from '../loader-event-handlers/importPublisherFromStart';
import { onTemplateImportSettingsClick } from '~core/templateImportSettings';
import { initContextMenuListeners } from '~src/utils/contextMenu';

export const initLoaderClickListeners = () => {
  $('body').on('click', '#requestFormat', requestNewFormat);
  $('body').on(
    'click',
    '#btn-import-publisher-start',
    importPublisherFromStart
  );
  $('body').on('click', '#btn-import-publisher-new', importPublisherFromStart);

  /**
   * Contextual Menu
   */

  initContextMenuListeners();
  $('body').on(
    'click',
    '[data-giotto-template-import-settings]',
    onTemplateImportSettingsClick
  );

  $('body').on('click', '[data-container-collapse]', (event) => {
    event.stopPropagation();
    const containerName = $(event.currentTarget).data('container-collapse');
    if ($(`#container-${containerName}`).hasClass('collapseBoxContainers')) {
      $(`#container-${containerName}`)
        .removeClass('collapseBoxContainers')
        .removeClass(`bg-color-${containerName}`);
      $(`#editor-${containerName}`).show();
      $(`#${containerName}-container-title`).show();
      $(`#editor-${containerName}-collapsed`).empty();
      $('#requestFormat').show();
    } else {
      templateCollapseBox();
    }
  });

  /**
   * Delete Format
   */
  $('body').on('click', '.menu-delete-format', async (e) => {
    const formatId = $(e.currentTarget).attr('data-id');
    const projectsCount = await fetchCountEditorProjectsByFormat(formatId);

    if (projectsCount.count > 0) {
      Swal.fire({
        text: `Non è possibile eliminare questo formato perché hai ${
          projectsCount.count == 1
            ? 'un progetto che usa questo formato.'
            : `${projectsCount.count} progetti che usano questo formato.`
        }`,
        icon: 'warning',
        confirmButtonColor: '#278e8e',
      });
    } else {
      Swal.fire({
        text: 'Sto eliminando il formato...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
      const deletedFormat = await deleteUserFormat(formatId);
      const selectedProjectType = getState('selected.tipo');

      if (deletedFormat.status == 204) {
        const newFormats = window.editorLoader.formats[
          selectedProjectType.objectId
        ].formats.items.filter((format) => format.objectId !== formatId);
        window.editorLoader.formats[
          selectedProjectType.objectId
        ].formats.items = newFormats;

        await renderLoader();
        await genericSuccess(
          'Eliminato',
          'Il formato è stato correttamente eliminato.'
        );
      } else {
        onErrorShowMessage('Non ho potuto eliminare il formato!');
      }
    }
  });
};
